import BossModel from "@/models/BossModel";
import Product from '@/models/Product/Product'
import Package from '@/models/Package/Package'

export default class RelatedProduct extends BossModel {

    /**
     * @type {string}
     */
    static apiUrl = 'product/relation';

    /**
     * @type {string}
     */
    static entity = 'relatedProducts';

    static fields() {
		return {
			id: this.attr(null),
			active_version_id: this.attr(null),
			travalco_eid: this.attr(null),
			travalco_code: this.attr(null),
            toProduct: this.belongsTo(Product, 'to_product_id'),
            toPackage: this.belongsTo(Package, 'to_package_id'),
            product: this.belongsTo(Product, 'product_id'),
            package: this.belongsTo(Package, 'package_id'),
		}
	}

    /**
     * @returns {boolean|*}
     * @constructor
     */
    Relatable(){
        if(this.IsProduct()) {
            return Product.find(this.to_product_id);
        }
        else if(this.IsPackage()){
            return Package.find(this.to_package_id);
        } else {
            throw 'no type for relatable found';
        }
    }

    /**
     * @returns {boolean|boolean}
     * @constructor
     */
    IsProduct() {
        return this.to_product_id !== null && this.to_product_id !== undefined;
    }

    /**
     * @returns {boolean|boolean}
     * @constructor
     */
    IsPackage() {
        return this.to_package_id !== null && this.to_package_id !== undefined;
    }

    /**
     * @returns {boolean|*}
     * @constructor
     */
    Package() {
        return this.getRelated('package');
    }

    /**
     * @returns {boolean|*}
     * @constructor
     */
    Product() {
        return this.getRelated('product');
    }
}
